// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AttractingInfo_wrapper__33Z5W","wrapperContainer":"AttractingInfo_wrapperContainer__3u8Cb"};